import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { createStyles, DialogTitle, Button, Icon as MUIIcon, IconButton as MUIIconButton, makeStyles, Menu, MenuItem, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import ButtonGroup from '../../Button/ButtonGroup';
import makeClass from 'classnames';
import { emphasisStyles } from '../../Theme';
var useStyles = makeStyles(function (theme) {
  return createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
      display: 'flex'
    },
    divider: {
      height: theme.spacing(2),
      padding: "".concat(theme.spacing(1.5), "px 0"),
      borderLeft: "1px solid ".concat(theme.palette.grey[200])
    },
    hasCloseButton: {
      paddingRight: theme.spacing(7)
    },
    headerText: {
      whiteSpace: 'nowrap'
    },
    backButton: {
      margin: 'auto',
      '& span': {
        fontSize: "3rem"
      }
    },
    primaryButton: {
      marginRight: theme.spacing(1)
    },
    headerActions: {
      transform: "translateY(-".concat(theme.spacing(1), "px)"),
      '& button:last-child': {
        '&::after': {
          content: '',
          borderRight: "1px solid ".concat(theme.palette.grey[500])
        }
      },
      minWidth: '300px'
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    }
  });
});

var sortActions = function sortActions(actions) {
  var primaryAction = actions.find(function (a) {
    return a.primary;
  });
  var nonPrimaryActions = actions.filter(function (a) {
    return !a.primary;
  });
  var visibleActions = nonPrimaryActions.length > 3 ? nonPrimaryActions.slice(0, 2) : nonPrimaryActions.slice(0, 3);
  var overflowActions = nonPrimaryActions.length > 3 ? nonPrimaryActions.slice(2) : null;
  return {
    primaryAction: primaryAction,
    visibleActions: visibleActions,
    overflowActions: overflowActions
  };
};

var ModalTitle = function ModalTitle(_ref) {
  var _makeClass3;

  var children = _ref.children,
      dsOnClose = _ref.dsOnClose,
      dsOnBack = _ref.dsOnBack,
      id = _ref.id,
      body = _ref.body,
      surtitle = _ref.surtitle,
      subtitle = _ref.subtitle,
      _ref$actions = _ref.actions,
      actions = _ref$actions === void 0 ? [] : _ref$actions;
  var classes = useStyles();
  var emphasis = emphasisStyles();

  var _sortActions = sortActions(actions),
      primaryAction = _sortActions.primaryAction,
      visibleActions = _sortActions.visibleActions,
      overflowActions = _sortActions.overflowActions;

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorPosition = _React$useState2[0],
      setAnchorPosition = _React$useState2[1];

  var open = Boolean(anchorPosition);

  var dropdownClose = function dropdownClose() {
    setAnchorPosition(undefined);
  };

  var actionIcons = (actions === null || actions === void 0 ? void 0 : actions.length) ? /*#__PURE__*/React.createElement(ButtonGroup, {
    align: "right",
    className: classes.headerActions
  }, primaryAction ? /*#__PURE__*/React.createElement(Button, {
    className: classes.primaryButton,
    "aria-label": primaryAction.label,
    variant: "outlined",
    color: "primary",
    onClick: primaryAction.dsClick,
    startIcon: /*#__PURE__*/React.createElement(MUIIcon, null, primaryAction.icon)
  }, primaryAction.label) : null, visibleActions.length ? visibleActions.map(function (action) {
    return /*#__PURE__*/React.createElement(MUIIconButton, {
      className: makeClass(_defineProperty({}, emphasis.low, true)),
      "aria-label": action.label,
      key: action.label,
      onClick: action.dsClick
    }, /*#__PURE__*/React.createElement(MUIIcon, null, action.icon));
  }) : null, (overflowActions === null || overflowActions === void 0 ? void 0 : overflowActions.length) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MUIIconButton, {
    className: makeClass(_defineProperty({}, emphasis.low, true)),
    "aria-label": "more",
    onClick: function onClick(event) {
      var rect = event.currentTarget.getBoundingClientRect();
      setAnchorPosition({
        top: rect.y + rect.height * 1.5,
        left: rect.x
      });
    }
  }, /*#__PURE__*/React.createElement(MUIIcon, null, "more_vert")), /*#__PURE__*/React.createElement(Menu, _extends({
    open: open,
    anchorReference: "anchorPosition"
  }, anchorPosition && {
    anchorPosition: anchorPosition
  }, {
    onClose: dropdownClose
  }), overflowActions.map(function (action) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: action.label,
      onClick: function onClick(event) {
        var _action$dsClick;

        dropdownClose();
        action === null || action === void 0 ? void 0 : (_action$dsClick = action.dsClick) === null || _action$dsClick === void 0 ? void 0 : _action$dsClick.call(action, event);
      }
    }, action.label);
  }))) : null, !!dsOnClose ? /*#__PURE__*/React.createElement("span", {
    className: classes.divider
  }) : null) : null;
  var backButton = !!dsOnBack ? /*#__PURE__*/React.createElement(MUIIconButton, {
    className: classes.backButton,
    "aria-label": "back",
    onClick: dsOnBack
  }, /*#__PURE__*/React.createElement(MUIIcon, null, "arrow_back")) : null;
  return /*#__PURE__*/React.createElement(DialogTitle, {
    disableTypography: true,
    id: id,
    className: makeClass((_makeClass3 = {}, _defineProperty(_makeClass3, classes.root, true), _defineProperty(_makeClass3, classes.hasCloseButton, !!dsOnClose), _makeClass3))
  }, backButton, /*#__PURE__*/React.createElement("div", {
    className: classes.headerText
  }, surtitle ? /*#__PURE__*/React.createElement(Typography, {
    variant: "overline",
    color: "textSecondary"
  }, surtitle) : null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, children, body), subtitle ? /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    color: "textSecondary"
  }, subtitle) : null), actionIcons, dsOnClose ? /*#__PURE__*/React.createElement(MUIIconButton, {
    "aria-label": "close",
    onClick: dsOnClose,
    className: classes.closeButton
  }, /*#__PURE__*/React.createElement(Close, null)) : null);
};

export default ModalTitle;

try {
  ModalTitle.__docgenInfo = {
    description: '',
    displayName: 'ModalTitle',
    methods: [],
    props: {
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      id: {
        defaultValue: null,
        description: '',
        name: 'id',
        required: false,
        type: {
          name: 'string'
        }
      },
      body: {
        defaultValue: null,
        description: '',
        name: 'body',
        required: false,
        type: {
          name: 'string'
        }
      },
      dsOnClose: {
        defaultValue: null,
        description: '',
        name: 'dsOnClose',
        required: false,
        type: {
          name: 'MouseEventHandler<HTMLButtonElement>'
        }
      },
      dsOnBack: {
        defaultValue: null,
        description: '',
        name: 'dsOnBack',
        required: false,
        type: {
          name: 'MouseEventHandler<HTMLButtonElement>'
        }
      },
      actions: {
        defaultValue: {
          value: '[]'
        },
        description: '',
        name: 'actions',
        required: false,
        type: {
          name: 'ModalTitleActions[]'
        }
      },
      subtitle: {
        defaultValue: null,
        description: '',
        name: 'subtitle',
        required: false,
        type: {
          name: 'string'
        }
      },
      surtitle: {
        defaultValue: null,
        description: '',
        name: 'surtitle',
        required: false,
        type: {
          name: 'string'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map